import { actions } from '../actions/Users';

const initialState = {
  processing: false,
  loading: false,
  timestamp: null,
  page: null,
  data: null,
  hasMore: true,
  selected: null,
  search: '',
  invite: {
    processing: false,
    success: false,
    errors: {},
  },
  edit: {
    processing: false,
    success: false,
    errors: {},
  },
  autocomplete: {
    loading: false,
    data: [],
  },
  register: {
    processing: false,
    success: false,
    errors: {},
  },
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET:
      return {
        ...state,
        loading: true,
      };
    case actions.PUT:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case actions.ITEM.RESET:
      return {
        ...state,
        edit: {
          ...state.edit,
          errors: {},
        },
        selected: null,
      };
    case actions.ITEM.PUT:
      return {
        ...state,
        edit: {
          ...state.edit,
          errors: {},
        },
        selected: action.payload,
      };
    case actions.EDIT.PROCESSING:
      return {
        ...state,
        edit: {
          ...state.edit,
          success: false,
          processing: true,
        },
      };
    case actions.EDIT.PROCESSED:
      return {
        ...state,
        edit: {
          ...state.edit,
          processing: false,
        },
      };
    case actions.EDIT.ERRORS:
      return {
        ...state,
        edit: {
          ...state.edit,
          errors: action.payload,
        },
      };
    case actions.EDIT.SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          errors: {},
          success: true,
        },
      };
    case actions.REGISTER.REQUEST:
      return {
        ...state,
        register: {
          ...state.register,
          processing: true,
        },
      };
    case actions.REGISTER.ERRORS:
      return {
        ...state,
        register: {
          ...state.register,
          processing: false,
          success: false,
          errors: action.payload,
        },
      };
    case actions.REGISTER.SUCCESS:
      return {
        ...state,
        register: {
          ...state.register,
          processing: false,
          errors: {},
          success: true,
        },
      };
    case actions.INVITE.PROCESSING:
      return {
        ...state,
        invite: {
          ...state.invite,
          success: false,
          processing: true,
        },
      };
    case actions.INVITE.PROCESSED:
      return {
        ...state,
        invite: {
          ...state.invite,
          processing: false,
        },
      };
    case actions.INVITE.ERRORS:
      return {
        ...state,
        invite: {
          ...state.invite,
          errors: action.payload,
        },
      };
    case actions.INVITE.SUCCESS:
      return {
        ...state,
        invite: {
          ...state.invite,
          errors: {},
          success: true,
        },
      };
    case actions.RESET:
      return {
        ...state,
        data: null,
        page: null,
        hasMore: true,
        timestamp: null,
      };
    case actions.AUTOCOMPLETE.GET:
      return {
        ...state,
        autocomplete: {
          ...state.autocomplete,
          loading: true,
        },
      };
    case actions.AUTOCOMPLETE.PUT:
      return {
        ...state,
        autocomplete: {
          loading: false,
          data: action.payload,
        },
      };
    case actions.AUTOCOMPLETE.CLEAR:
      return {
        ...state,
        autocomplete: {
          loading: false,
          data: [],
        },
      };
    default:
      return state;
  }
};

export default usersReducer;
